import irelandApi from '../irelandApi';

export const getFeatures = () => dispatch =>
  irelandApi
    .get('/api/features')
    .then(({ data }) =>
        dispatch({ type: 'FEATURES_LOADED', payload: data })
    )
    .catch(error => dispatch({ type: 'FEATURES_FAILED' }));

export const getSystemMessage = () => dispatch =>
  irelandApi
    .get('/api/features/system_message')
    .then(({ data }) =>
      dispatch({ type: 'SYSTEM_MESSAGE_LOADED', payload: data })
    )
    .catch(error => dispatch({ type: 'SYSTEM_MESSAGE_FAILED' }));



// WEBPACK FOOTER //
// ./src/actions/features.js